import { GetServerSideProps } from 'next';

import { getSharedPageData, SharedPageData } from 'utils/shared-page-data';
import { parseQuickLinks } from 'lib/sanity/helpers/quickLinksHelper';
import { getHomePageData } from 'lib/sanity';
import HomePage, { HomepageProps } from 'components/Homepage';
import { Vertical } from 'utils/vertical';
import { sendCounterMetric, Whats } from 'utils/metrics';
import { emptyParentCategoryFilter } from 'utils/sanity';
import { NotFoundError } from 'utils/errors';
import { serverExceptionHandler } from 'utils/exceptionHandler';

const MISSING_DATA = 'Missing home data';
const getHomepageData = async (market: string, vertical: Vertical) => {
  const { quickLinks, categories, banner, masthead: mastheadData } = await getHomePageData(market, vertical);

  const parsedQuickLinks = parseQuickLinks(quickLinks);
  // Hide the categories that have no subcategories/available articles
  const filteredCategories = categories.filter(emptyParentCategoryFilter);

  if (!filteredCategories.length || !parsedQuickLinks.length) {
    sendCounterMetric(Whats.MISSING_DATA, { page: 'home', market, vertical });
    throw new NotFoundError(MISSING_DATA);
  }

  return { quickLinks: parsedQuickLinks, categories: filteredCategories, banner, mastheadData };
};

export const getServerSideProps: GetServerSideProps<HomepageProps> = async context => {
  const { query } = context;
  const market = query.market as string;
  let vertical: Vertical | undefined;
  let sharedPageData: SharedPageData | undefined;

  try {
    sharedPageData = await getSharedPageData(context);
    vertical = sharedPageData.vertical;
    const { mastheadData, ...data } = await getHomepageData(market, vertical);
    return { props: { data, mastheadData, sharedPageData } };
  } catch (error) {
    return serverExceptionHandler(error, 'home-page', { market, vertical });
  }
};

export default HomePage;
